import { useState } from "react";

export const useGemini = () => {
  const [loading, setLoading] = useState(false);
  const apiKey = "AIzaSyD6id7h7c2iWIPBy1FTsdJxzwzWYqiL03U";

  const ask = async (
    prompt: string,
  ): Promise<{ answer: string; loading: boolean }> => {
    setLoading(true);

    try {
      const response = await fetch(
        `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent?key=${apiKey}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            contents: [
              {
                parts: [{ text: prompt }],
              },
            ],
          }),
        },
      );
      const data = await response.json();
      setLoading(false);
      if (response.status === 429) {
        return {
          answer: "Exceeded quota :(( Sorry about that!",
          loading: false,
        };
      }
      return {
        answer:
          data.candidates?.[0]?.content?.parts?.[0].text ||
          "Không có câu trả lời phù hợp.",
        loading: false,
      };
    } catch (error) {
      setLoading(false);
      console.error("Lỗi khi gọi API Gemini:", error);
      return {
        answer: "Đã xảy ra lỗi. Vui lòng thử lại.",
        loading: false,
      };
    }
  };

  return { ask, loading };
};
